/* eslint-disable no-undef */
import { useTranslation } from 'react-i18next';
import {
    Box,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Link,
    Typography,
} from '@mui/material';
import './styles.css';
import { ReactComponent as LocationIcon } from '../../assets/icons/location.svg'

const ProductCard = ({ imageUrl, location, price, rate, reviews, title, path }) => {
    const { t } = useTranslation(['tours', 'components']);
    const image = imageUrl;
    return (
        <Link href={path} sx={{ textDecoration: "none" }} title={"Más información sobre " + title}>
            <Card
                id="productCard"
                sx={{
                    maxWidth: 340,
                    width: { xs: 'auto', md: 340 },
                    height: { xs: 380, md: 420 },
                    boxShadow: 10,
                    borderRadius: 2
                }}>
                <CardMedia
                    sx={{
                        marginBottom: -2,
                        transition: 'filter 0.5s ease-in-out',
                        filter: 'brightness(100%)',
                        [`#productCard:hover &`]: {
                            filter: 'brightness(60%)'
                        }
                    }}
                    image={image}
                    title={title}
                />
                <Box
                    sx={{
                        px: { xs: 0, md: '.8rem' },
                        width: '100%',
                        bgcolor: '#ffffff',
                        transition: 'background-color 1.0s',
                        position: 'absolute',
                        paddingBottom: '15px',
                        bottom: 0,
                        [`#productCard:hover &`]: {
                            bgcolor: 'transparent'
                        }
                    }}>
                    <CardContent>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                py: '.5rem',
                                px: 0
                            }}>
                            <LocationIcon
                                height={18}
                                width={12}
                                style={{ marginRight: '.5rem', marginTop: '.2rem' }}
                            />
                            <Typography
                                variant="body2"
                                color="#666B6E"
                                fontFamily={'Inter'}
                                fontSize={17}
                                fontWeight={350}
                            >
                                {location}
                            </Typography>
                        </Box>
                        <Typography component="h3" variant="subtitle1">{title}</Typography>
                    </CardContent>
                    <CardActions sx={{ py: 0 }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 35,
                                borderRadius: 2,
                                bgcolor: 'secondary.main',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: 0.5,
                                marginBottom: 2
                            }}>
                            <Typography
                                variant="h6"
                                color="primary.contrastText"
                                sx={{ fontWeight: 'bold' }}>
                                {rate}
                            </Typography>
                        </Box>
                        <Typography
                            mb={2}
                            pl={1}
                            fontFamily={'Poppins'}
                            sx={{
                                display: { xs: 'none', md: 'flex' }
                            }}>
                            {`${reviews.state}`}
                        </Typography>
                        <Typography
                            mb={2}
                            fontFamily={'Poppins'}
                            sx={{
                                fontSize: { xs: '14px', md: '16px' }
                            }}>
                            {`(${reviews.number} Reviews)`}
                        </Typography>
                    </CardActions>
                    <CardActions sx={{ py: 0, ml: '.3rem' }}>
                        <Typography
                            color="secondary"
                            sx={{
                                fontSize: { xs: '14px', md: '18px' },
                                fontWeight: { xs: 600, md: 700 }
                            }}>
                            {`${price} €`}
                        </Typography>
                    </CardActions>
                    {/* <CardActions sx={{ py: 0, ml: '.3rem' }}>
                        <Typography
                            color="grayText"
                            sx={{
                                fontSize: { xs: '10px', md: '12px' },
                                fontWeight: 400
                            }}>
                            {t('IVAincluded')}
                        </Typography>
                    </CardActions> */}
                </Box>
            </Card>
        </Link>
    )
}

export default ProductCard
